import axios from 'axios'

export default class PaginatedResults {
    constructor (items = []) {
        this.page = 1
        this.busy = false
        this.completed = false
        this.items = items
    }

    fetch (url) {
        this.busy = true

        let params = {
            page: this.page
        }

        return axios.get(url, { params })
    }

    addItems (data) {
        if (this.page > 1) {
            this.items.push.apply(this.items, data.data)
        } else {
            this.items = data.data
        }

        this.completed = this.page === data.last_page

        if (this.completed === false) {
            this.page = data.current_page + 1
        }

        this.busy = false
    }

    isEmpty () {
        return this.items.length === 0
    }

    canLoadMore () {
        return this.busy === false && this.completed === false
    }
}
